import React, { useEffect, useState } from 'react';
import ContactForm from '../ContactForm/index.jsx';

import _service from '@netuno/service-client';

import './index.less';

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ data, width }) => {
  const [loading, setLoading] = useState(true);
  const [configurations, setConfigurations] = useState({});

  useEffect(() => {
    _service({
      url: "/remote/config",
      success: (response) => {
        if (response.json) {
          setConfigurations(response.json);
          setLoading(false);
        }
      },
      fail: (e) => {
        setLoading(false);
        console.error("Service /remote/config failed.", e);
      }
    });
  }, []);

  if (loading) {
    return <div />;
  }

  let phone = configurations.phone;
  let formattedPhone = configurations.phone;
  if (configurations.phone) {
    phone = phone.split(' ').join('').split('-').join('');
  }

  return (
    <footer style={{ width }}>
      <ContactForm data={data} phone={phone} formattedPhone={formattedPhone} email={configurations.email} />
    </footer>
  );
};
